import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ReloadCurrentUserWidget: WidgetRegistryEntry = {
  name: "ReloadCurrentUser",
  component: () => import("./reload-current-user-widget.component").then((m) => m.ReloadCurrentUserWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.ReloadCurrentUserWidget)
};
